var map = {
	"./img/HTU-modal/htu-1.jpg": 1188,
	"./img/HTU-modal/htu-10.jpg": 1197,
	"./img/HTU-modal/htu-11.jpg": 1198,
	"./img/HTU-modal/htu-12.jpg": 1199,
	"./img/HTU-modal/htu-13.jpg": 1200,
	"./img/HTU-modal/htu-2.jpg": 1189,
	"./img/HTU-modal/htu-3.jpg": 1190,
	"./img/HTU-modal/htu-4.jpg": 1191,
	"./img/HTU-modal/htu-5.jpg": 1192,
	"./img/HTU-modal/htu-6.jpg": 1193,
	"./img/HTU-modal/htu-7.jpg": 1194,
	"./img/HTU-modal/htu-7.png": 1653,
	"./img/HTU-modal/htu-8.jpg": 1195,
	"./img/HTU-modal/htu-9.jpg": 1196,
	"./img/alert-icon.png": 1654,
	"./img/angle-down.png": 1655,
	"./img/arc-arrow.png": 1222,
	"./img/arrival.svg": 1656,
	"./img/arrows.png": 1133,
	"./img/attention.svg": 1657,
	"./img/avatar.png": 1183,
	"./img/bad.png": 1225,
	"./img/bed.svg": 1182,
	"./img/bg.jpg": 1658,
	"./img/cal-check.png": 1179,
	"./img/calculator.png": 1205,
	"./img/calendar-check.svg": 1659,
	"./img/dirty-icon.svg": 1108,
	"./img/edit-res-base.png": 1186,
	"./img/favicon.ico": 1660,
	"./img/flags.png": 1661,
	"./img/good.png": 1226,
	"./img/graph.svg": 1201,
	"./img/image-upload.png": 1662,
	"./img/img-public.jpg": 1663,
	"./img/in.svg": 1184,
	"./img/incoming.png": 1203,
	"./img/integration.png": 1664,
	"./img/landing/F-desk-manage.png": 1223,
	"./img/landing/FF-PMS.png": 1214,
	"./img/landing/booking-engine.png": 1135,
	"./img/landing/booking-logo-gs.png": 1207,
	"./img/landing/booking-logo.png": 1206,
	"./img/landing/channel-manager.png": 1134,
	"./img/landing/clients-icon.png": 1220,
	"./img/landing/computer-bg.jpg": 1216,
	"./img/landing/contact-icon.png": 288,
	"./img/landing/expedia-logo-gs.png": 1213,
	"./img/landing/expedia-logo.png": 1212,
	"./img/landing/hostel-world-logo-gs.png": 1209,
	"./img/landing/hostel-world-logo.png": 1208,
	"./img/landing/info-icon.png": 1221,
	"./img/landing/inner-bg.jpg": 1665,
	"./img/landing/moon-icon.png": 1219,
	"./img/landing/payment.png": 1215,
	"./img/landing/phone-icon.png": 287,
	"./img/landing/pms-bg.jpg": 1666,
	"./img/landing/rooms-icon.png": 1217,
	"./img/landing/support-woman.jpg": 1667,
	"./img/landing/support.png": 1224,
	"./img/landing/tripadvisor-logo-gs.png": 1211,
	"./img/landing/tripadvisor-logo.png": 1210,
	"./img/landing/yearly-trans-icon.png": 1218,
	"./img/legend.jpg": 1187,
	"./img/loader.svg": 1668,
	"./img/logo-104x17.eng.png": 1669,
	"./img/logo-lg.png": 1104,
	"./img/logo-short.jpg": 286,
	"./img/logo.png": 84,
	"./img/luggage-cart-solid.svg": 1670,
	"./img/man.svg": 1180,
	"./img/man2.svg": 1181,
	"./img/out.svg": 1185,
	"./img/paid-out.png": 1204,
	"./img/sa-flag-md.png": 87,
	"./img/sa-flag.png": 1671,
	"./img/superb.png": 1227,
	"./img/test-img.jpg": 1672,
	"./img/tidy-icon.svg": 1107,
	"./img/upload.png": 1673,
	"./img/usa-flag-md.png": 86,
	"./img/usa-flag.png": 1674,
	"./img/user-profile-bg.jpg": 1675,
	"./img/zatca.png": 1202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1652;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 1652
// module chunks = 7